import { LoadingOutlined } from "@ant-design/icons";

import { handleTrackingButtonOnClick } from "./index";

export default function SecondaryButton({
  text,
  onClick,
  loading,
  success,
  error,
}: any) {
  const loadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const renderInnerComponent = () => {
    if (loading) {
      return loadingIcon;
    }
    if (success) {
      return text;
    }
    if (error) {
      return text;
    }
    return text;
  };

  return (
    <>
      <button
        type="button"
        className="focus:outline-none inline-flex h-8 w-20 items-center justify-center rounded border border-transparent bg-indigo-100 px-2.5 py-1.5 text-xs font-medium text-indigo-700 hover:bg-indigo-200 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        onClick={() => handleTrackingButtonOnClick(text, onClick)}
      >
        {renderInnerComponent()}
      </button>
    </>
  );
}
